import assignInWith from 'lodash/assignInWith';
import { BaseAPIClient } from './base-api-client';

import './axios-setup';

type FinalAPIClient<T> = BaseAPIClient & {
  [K in keyof T]: T[K] & BaseAPIClient;
};

export function buildApiClient<T extends object>(
  config: { apiRoot: string },
  extendedModules?: T,
): FinalAPIClient<T> {
  const instance = new BaseAPIClient({
    apiRoot: config.apiRoot,
  });

  assignInWith(instance, extendedModules, (_objValue, module) => {
    return assignInWith({}, module, (_objValue, method) => {
      return method.bind(instance);
    });
  });

  return instance as FinalAPIClient<T>;
}
